import { apis } from "./base";

const quotesService = apis.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuotesByCountry: builder.query({
      query: (country_id) => `/admin/quotes/all/${country_id}`,
      transformResponse: (response) => response.response,
      providesTags: ["Quotes"],
    }),
    getAllQuotesByCompany: builder.query({
      query: (company_id) => `/admin/companies/quotes/${company_id}`,
      transformResponse: (response) => response.response,
      providesTags: ["Quotes"],
    }),
    getQuoteProductsByQuoteId: builder.query({
      query: (quote_id) => `/admin/quotes/products/${quote_id}`,
      transformResponse: (response) => response.response,
    }),
    getQuoteDetailsByQuoteId: builder.query({
      query: (quote_id) => `/admin/quotes/details/${quote_id}`,
      transformResponse: (response) => response.response,
      providesTags: ["Quotes"],
    }),
    resendQuoteCreatedEmail: builder.mutation({
      query: ({ quoteId }) => ({
        url: `/admin/quotes/resend-email/${quoteId}`,
        method: "POST",
        body: {},
      }),
    }),
    createQuote: builder.mutation({
      query: (data) => ({
        url: `/admin/quotes/create`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Quotes"],
    }),
    editQuote: builder.mutation({
      query: (data) => ({
        url: `/admin/quotes/edit/${data.id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Quotes"],
    }),
    convertQuote: builder.mutation({
      query: (data) => ({
        url: `/admin/quotes/convert/${data.id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Quotes"],
    }),
    cancelQuote: builder.mutation({
      query: (data) => ({
        url: `/admin/quotes/cancel/${data.quoteId}`,
        method: "POST",
        body: {
          countryId: data.countryId,
        },
      }),
      invalidatesTags: ["Quotes"],
    }),
  }),
});

export const {
  useGetAllQuotesByCountryQuery,
  useLazyGetAllQuotesByCountryQuery,
  useGetAllQuotesByCompanyQuery,
  useLazyGetAllQuotesByCompanyQuery,
  useResendQuoteCreatedEmailMutation,
  useCreateQuoteMutation,
  useConvertQuoteMutation,
  useCancelQuoteMutation,
  useLazyGetQuoteProductsByQuoteIdQuery,
  useLazyGetQuoteDetailsByQuoteIdQuery,
  useEditQuoteMutation,
} = quotesService;
